var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.35147 8.75186C6.8201 8.28323 7.5799 8.28323 8.04853 8.75186L12 12.7033L15.9515 8.75186C16.4201 8.28323 17.1799 8.28323 17.6485 8.75186C18.1171 9.22049 18.1171 9.98029 17.6485 10.4489L12.8485 15.2489C12.3799 15.7175 11.6201 15.7175 11.1515 15.2489L6.35147 10.4489C5.88284 9.98029 5.88284 9.22049 6.35147 8.75186Z",
    fill: "#5C6C7F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/Chevron Down.f2aece864cea831c00d11dd094f24a32.svg";
export { ForwardRef as ReactComponent };